import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';

import {AppComponent} from './app/app.component';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {freezeStoresStatesHook} from './app/common/elf-store/hooks';

if (environment.production) {
  enableProdMode();
}

freezeStoresStatesHook();

bootstrapApplication(AppComponent, {
  providers: [importProvidersFrom(AppModule), provideZoneChangeDetection()],
}).catch(err => console.error(err));
